import { render } from "./HeaderDetails.vue?vue&type=template&id=0016f472"
import script from "./HeaderDetails.vue?vue&type=script&lang=js"
export * from "./HeaderDetails.vue?vue&type=script&lang=js"

import "./HeaderDetails.vue?vue&type=style&index=0&id=0016f472&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__